import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@ngneat/transloco';
import { Observable } from 'rxjs';

import cacheBustingJson from '../../i18n-cache-busting.json';

const CACHE_BUSTING: Record<string, string> = cacheBustingJson as Record<string, string>;

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoaderService implements TranslocoLoader {
    constructor(private http: HttpClient) {}

    getTranslation(lang: string): Observable<Translation> {
        const path = `/assets/i18n/${lang}.json?v=${CACHE_BUSTING[lang]}`;
        return this.http.get<Translation>(path);
    }
}
